import React, {Fragment} from "react";
import Separatore from "../../../../../components/Spearatore";
import TabellaQuoteCertificatoController from "./tabella-quote/TabellaQuoteCertificatoController";
import TabellaMovimentiCertificatoController from "./tabella-movimenti/TabellaMovimentiCertificatoController";

export default function TabellaPagamentiCertificatoView({
                                                 certificato,
                                             }) {

    return (
        <Fragment>
            <Separatore>
                Quote versate
            </Separatore>
            <TabellaQuoteCertificatoController
                certificato={certificato}
            />
            <Separatore>
                Movimenti
            </Separatore>
            <TabellaMovimentiCertificatoController
                certificato={certificato}
            />
        </Fragment>
    );
}